// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-wrapper-table-a-cell {
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
}
.fi-wrapper-table-a-cell .BrandedColorHover {
  transition: 0.2s;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-wrapper-table/cells/fi-wrapper-table-a-cell/fi-wrapper-table-a-cell.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,kBAAA;EACA,mBAAA;AACJ;AACI;EACI,gBAAA;AACR","sourcesContent":[".fi-wrapper-table-a-cell {\r\n    text-overflow: ellipsis;\r\n    overflow-x: hidden;\r\n    white-space: nowrap;\r\n\r\n    .BrandedColorHover {\r\n        transition: 0.2s;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
